import { render, staticRenderFns } from "./knowledgeManagement.vue?vue&type=template&id=a6299538&scoped=true"
import script from "./knowledgeManagement.vue?vue&type=script&lang=js"
export * from "./knowledgeManagement.vue?vue&type=script&lang=js"
import style0 from "./knowledgeManagement.vue?vue&type=style&index=0&id=a6299538&prod&lang=less"
import style1 from "./knowledgeManagement.vue?vue&type=style&index=1&id=a6299538&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6299538",
  null
  
)

export default component.exports